// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_7Rs","cls2":"AuthorPopover-cls2_nl- AuthorPopover-cls1_7Rs"};